<template>
  <v-layout wrap style="height: 100px;">
    <v-navigation-drawer v-model="showFilters" persistent fixed width="600">
        <v-toolbar  color="white" class="elevation-0" >
          <v-toolbar-title>Filtros</v-toolbar-title>
        </v-toolbar>
        <v-spacer></v-spacer>
      <v-form>
        <v-container>
          <v-layout>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuStartAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedStartAtFormatted"
                    label="Data Inicial"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="startAt" no-title @input="menuStartAt = false" class=“no-pointer-events”></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuEndAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndAtFormatted"
                    label="Data Final"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="endAt" no-title @input="menuEndAt = false"></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
            <div>
              <v-subheader>Outros Filtros</v-subheader>
            </div>
          <v-layout v-if="partnerLevel === 'establishment'">
              <!--blank if establishment-->
          </v-layout>
          <!-- <v-layout v-else>
              <partner />
          </v-layout> -->
          <v-layout>
            <v-text-field
              v-model="accountId"
              label="ID do Estabelecimento"
              required
              prepend-icon="fingerprint">
            </v-text-field>
          </v-layout>
          <v-layout>
              <status />
              <brand />
          </v-layout>

           <v-layout>
              <terminal-number />
              <operation />
          </v-layout>
          <v-layout>
              <order />
          </v-layout>

          <v-btn @click="getResources">Enviar</v-btn>
          <v-btn @click="reset">Limpar</v-btn>
          <v-btn @click="desableFilters">Fechar</v-btn>
        </v-container>
      </v-form>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  created() {
    this.$store.dispatch("account/getAccount");
  },
  components: {
    Status: () => import("./options/Status.vue"),
    Brand: () => import("./options/Brand.vue"),
    TerminalNumber: () => import("./options/TerminalNumber.vue"),
    Operation: () => import("./options/Operation.vue"),
    Order: () => import("./options/Order.vue"),
    Partner: () => import("./options/Partner.vue"),
  },
  data: (vm) => ({
    startAt: null,
    endAt: new Date().toISOString().substr(0, 10),
    startAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'start'),
    endAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'end'),
    menuStartAt: false,
    menuEndAt: false,
    accountId: null
  }),
  computed: {
    ...mapGetters({
      filters: "partners_payments/filter",
      status: "partners_payments/filtersStatus",
      credit_card_brand: "partners_payments/filtersCardBrand",
      terminalNumber: "partners_payments/filtersTerminalNumber",
      operation: "partners_payments/filtersOperation",
      ordination: "partners_payments/filtersOrdination",
      showFilters: "partners_payments/showFilters",
      partner: "partners_payments/filtersPartner",
      partnerLevel: "account/partner",
    }),
    computedStartAtFormatted() {
      return this.formatDate(this.startAt, 'start');
    },
    computedEndAtFormatted() {
      return this.formatDate(this.endAt, 'end');
    },
  },
  watch: {
    startAt(val) {
      this.startAtFormatted = this.formatDate(this.startAt, 'start');
      this.$store.state.partners_payments.filterParams.filterrific.with_created_at_between.start_at =
        this.startAtFormatted;
    },
    endAt(val) {
      this.endAtFormatted = this.formatDate(this.endAt, 'end');
      this.$store.state.partners_payments.filterParams.filterrific.with_created_at_between.end_at =
        this.endAtFormatted;
    },
  },
  methods: {
    getResources() {
      this.params = {
        page: this.page,
        limit: this.limit,
        filterrific: {
          with_created_at_between: {
            start_at: this.startAt,
            end_at: this.endAt,
          },
          status: this.status,
          credit_card_brand: this.credit_card_brand,
          with_terminal_number: this.terminalNumber,
          operation: this.operation,
          with_partner: this.partner,
          sorted_by: this.ordination,
          with_account_id: this.accountId
        },
      };
      this.$store.state.partners_payments.filterParams = this.params;
      this.$store.dispatch("partners_payments/load", this.params);
      this.$store.dispatch("partners_payments/showFilters", false);
    },
    desableFilters() {
      this.$store.dispatch("partners_payments/showFilters", false);
    },
    reset() {
      this.$store.dispatch("partners_payments/resetFilters", this.filters);
      this.$store.dispatch("partners_payments/load");
      this.$store.dispatch("partners_payments/showFilters", false);
    },
    formatDate(date, kind) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (kind == 'start') { 
        return `${day}/${month}/${year} 00:00:00`;
      } else {
        return `${day}/${month}/${year} 23:59:00`;
      } 
    }
  },
};
</script>
